import { Hue, IRecord, IRecordType } from 'annotation-tools/utils';

// immutable object generator
export const ILabelFromApi = IRecord<LabelFromApiType>({
  id: 0,
  name: '',
  hue: 1,
  numUsedInModelAnnotation: 0,
  numUsedInProjectAnnotation: 0,
  canBeDeleted: true
});

// immutable type
export type ILabelFromApiType = IRecordType<LabelFromApiType>;

type LabelFromApiType = {
  id: number;
  name: string; // ラベル名 [1..50] characters
  hue: Hue;
  numUsedInModelAnnotation: number; // 学習での利用数
  numUsedInProjectAnnotation: number; // プロジェクトでの利用数
  canBeDeleted: boolean;
};
